import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import { Icon } from "@syarahtech/ui";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import useHelpers from "@hooks/useHelpers";

// Tailwind clone of DeskTopBlueMobileWhiteHeader, scoped to the tracking-landing
// page: mobile header has no bottom padding (pt-4 only).
var TrackingLandingHeader = function TrackingLandingHeader(_ref) {
  var title = _ref.title,
    onBack = _ref.onBack;
  var webview = useWebView();
  var isWebView = useIsWebView();
  useEffect(function () {
    webview.showTitleBar(false)["catch"](function () {});
  }, [isWebView]);
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "block fixed left-0 top-0 -z-[1] w-full h-full bg-[#FBFBFB]"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center sticky top-0 z-[9] bg-white pt-4 min-[1025px]:static min-[1025px]:bg-primary-new min-[1025px]:h-[112px] min-[1025px]:p-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container relative min-[1025px]:px-[100px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden min-[1025px]:flex items-center"
  }, onBack && /*#__PURE__*/React.createElement("div", {
    id: "tracking-header-back-desktop",
    className: "shrink-0 flex items-center ltr:rotate-180 pe-4 ltr:ps-4 cursor-pointer text-white",
    onClick: onBack
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios-rounded",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-white text-[32px] leading-[48px]"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "relative flex items-center justify-center min-[1025px]:hidden"
  }, /*#__PURE__*/React.createElement("div", {
    id: "tracking-header-back-mobile",
    className: "absolute start-0 top-1/2 -translate-y-1/2 shrink-0 flex items-center ltr:rotate-180 cursor-pointer text-[#154f9c]",
    onClick: onBack ? onBack : function () {
      return navigateTo("/");
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--arrow-forward-ios-rounded",
    className: "text-primary-new",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-[#00143C] text-[16px] leading-6 font-bold"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "border-t border-solid border-[#E1E8F2] w-full mt-[10px] min-[1025px]:border-0 min-[1025px]:mt-0"
  }))));
};
export default TrackingLandingHeader;